import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';

const initialState = {
  commonData: {},
};

// Reducer function.
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COMMON_DATA:
      return updateObject(state, {commonData: action.state});
    default:
      return state;
  }
};

export default reducer;
